

export const URLS = {
    ARTICLES: {
        list: "store/v1/articles/",
        details: (id: string) => `store/v1/articles/${id}/`
    }
}